import Vue from 'vue';
import debounce from 'lodash/debounce';

// Usage:
//    <button
//      v-debounce.click="dealWithClick"
//      v-debounce:50.blur="handleBlur"
//      v-debounce:4000.blur="longTimeAfterBlur"
//      v-debounce:200.click="justDoIt.bind(this, 'like this')"
//      v-debounce:201.click="() => justDoIt('like this')"
//    >
//      Click me
//    </button>

Vue.directive('debounce', {
  bind: function(el, binding) {
    const delay = binding.arg ? parseInt(binding.arg) : 300;
    const eventName = Object.keys(binding.modifiers)[0];
    const callback = binding.value;

    el.addEventListener(eventName, debounce(callback, delay));
  },
});
